import { createUseStyles } from 'react-jss'

export const style = {
  field: {
    marginRight: 3,
    marginBottom: 3
  },
  deleteAction: {
    marginRight: 3
  },
  deleteSpacer: {
    width: 41
  }
}

export const useStyles = createUseStyles(style)
